/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectCommandResult } from '../../models/create-project-command-result';
import { ProjectFinancingStakholder } from '../../models/project-financing-stakholder';
import { ProjectImportance } from '../../models/project-importance';
import { ProjectSection } from '../../models/project-section';
import { ProjectStates } from '../../models/project-states';
import { ProjectStatus } from '../../models/project-status';
import { ProjectType } from '../../models/project-type';

export interface ApiProjectCreateProjectPost$Plain$Params {
      body?: {
'Name': string;
'CodeNumber'?: string;
'ManagerId'?: string;
'EstimatedStartDate'?: string;
'EstimatedEndDate'?: string;
'ActualStartDate'?: string;
'ActualEndtDate'?: string;
'Description'?: string;
'ProjectStatus'?: ProjectStatus;
'ProjectType'?: ProjectType;
'EstimatedCost'?: number;
'ActualCost'?: number;
'Lat'?: number;
'Lon'?: number;
'ProjectState'?: ProjectStates;
'ConstructionId'?: string;
'ConsultingId'?: string;
'StackholderId'?: number;
'ConsultativeManagerId'?: string;
'ConstructionManagerId'?: string;
'Priority'?: number;
'Importance'?: ProjectImportance;
'FinancingStakholder'?: ProjectFinancingStakholder;
'Section'?: ProjectSection;
'Notes'?: string;
'Year'?: number;
'QuarterId'?: string;
'ContractNumber'?: string;
'VatValue'?: number;
'Attachments'?: Array<Blob>;
'CategoryId'?: string;
'ContainerId'?: string;
}
}

export function apiProjectCreateProjectPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectCreateProjectPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCreateProjectPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectCommandResult>;
    })
  );
}

apiProjectCreateProjectPost$Plain.PATH = '/api/Project/CreateProject';
